import React, { useCallback, useEffect, useState } from "react";
import { Button, CircularProgress, MenuItem, TextField } from "@mui/material";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const panel = {
  border: "1px solid #dfe4e1",
  borderRadius: 16,
  background: "#fff",
  padding: 16,
};

export default function TasksPanel({ users = [], isAdmin, onChanged }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [title, setTitle] = useState("");
  const [priority, setPriority] = useState("medium");
  const [dueAt, setDueAt] = useState("");
  const [assignedUserId, setAssignedUserId] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/dashboard/v2/tasks");
      setTasks(Array.isArray(data) ? data : []);
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const createTask = async event => {
    event.preventDefault();
    if (!title.trim() || saving) return;
    setSaving(true);
    try {
      await api.post("/dashboard/v2/tasks", {
        title: title.trim(),
        priority,
        dueAt: dueAt || null,
        assignedUserId: assignedUserId || undefined,
      });
      setTitle("");
      setDueAt("");
      setAssignedUserId("");
      await load();
      onChanged?.();
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  const changeStatus = async (id, status) => {
    try {
      await api.patch(`/dashboard/v2/tasks/${id}`, { status });
      await load();
      onChanged?.();
    } catch (error) {
      toastError(error);
    }
  };

  return (
    <section style={panel}>
      <h2 style={{ margin: "0 0 12px", fontSize: 16 }}>Tarefas</h2>
      <form onSubmit={createTask} style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
        <TextField size="small" label="Nova tarefa" value={title} onChange={event => setTitle(event.target.value)}
          inputProps={{ maxLength: 160 }} style={{ flex: "1 1 220px" }} required />
        <TextField size="small" select label="Prioridade" value={priority} onChange={event => setPriority(event.target.value)} style={{ minWidth: 120 }}>
          <MenuItem value="low">Baixa</MenuItem><MenuItem value="medium">Média</MenuItem><MenuItem value="high">Alta</MenuItem>
        </TextField>
        <TextField size="small" type="datetime-local" label="Prazo" InputLabelProps={{ shrink: true }} value={dueAt}
          onChange={event => setDueAt(event.target.value)} />
        {isAdmin && <TextField size="small" select label="Responsável" value={assignedUserId}
          onChange={event => setAssignedUserId(event.target.value)} style={{ minWidth: 150 }}>
          <MenuItem value="">Eu mesmo</MenuItem>
          {users.map(person => <MenuItem key={person.id} value={person.id}>{person.name}</MenuItem>)}
        </TextField>}
        <Button type="submit" variant="contained" disabled={saving}>Criar</Button>
      </form>
      {loading ? <CircularProgress size={22} /> : tasks.length === 0 ? <p>Nenhuma tarefa criada.</p> : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead><tr><th align="left">Tarefa</th><th align="left">Responsável</th><th align="left">Prazo</th><th align="left">Status</th><th /></tr></thead>
            <tbody>{tasks.map(task => (
              <tr key={task.id} style={{ borderTop: "1px solid #e9ecea" }}>
                <td style={{ padding: "10px 5px" }}>{task.title}</td>
                <td>{task.assignee || "—"}</td>
                <td>{task.dueAt ? new Date(task.dueAt).toLocaleString("pt-BR") : "—"}</td>
                <td>{task.status === "completed" ? "Concluída" : task.status === "cancelled" ? "Cancelada" : "Pendente"}</td>
                <td>{task.status !== "completed" && task.status !== "cancelled" && (
                  <Button size="small" onClick={() => changeStatus(task.id, "completed")}>Concluir</Button>
                )}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </section>
  );
}
